type Partner = {
  name: string;
  logo: string;
  colorizeBrandOnlyOnHover?: boolean;
};
const partners: Partner[] = [{
  name: 'Auto Centar 7',
  logo: 'https://cdn.magicpatterns.com/uploads/1fqM9kKbe2hFhrra1ojcUq/2.png'
}, {
  name: 'Forza Properties',
  logo: 'https://cdn.magicpatterns.com/uploads/9DuJDoXqE3yscoFZMSV47t/1.png',
  colorizeBrandOnlyOnHover: true
}, {
  name: 'Optika Lučić',
  logo: 'https://cdn.magicpatterns.com/uploads/oDp4YLLs6PRiVX4c2Ewa3f/3.png'
}, {
  name: 'Radovanović Selidbe',
  logo: 'https://cdn.magicpatterns.com/uploads/c7dhTLqhUx3tprqE6qxhC8/Untitled_design.png'
}];
export function References() {
  return <section className="bg-dark-bg py-4 md:py-5" aria-label="Reference" data-id="element-294" data-mp="2zhscsstxeff9">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8" data-id="element-295" data-mp="2ulbh9dkecys5">
        <ul className="grid grid-cols-2 items-center gap-x-2 gap-y-4 sm:grid-cols-4 sm:gap-x-4 md:gap-x-6" data-id="element-296" data-mp="155c3tk9qwn6p">
          {partners.map(partner => <li key={partner.name} className="flex min-w-0 items-center justify-center" data-id="element-297" data-mp="108loiz5rlvmc">
              <span className="group inline-flex items-center justify-center px-2 py-1.5 transition-transform duration-300 hover:scale-105" data-id="element-298" data-mp="27vlbbawczcsn">
                <span className="relative inline-block" data-id="element-299" data-mp="2hs7vdxgv1ztm">
                  <img src={partner.logo} alt={partner.name} loading="lazy" className={`h-16 w-auto max-w-[42vw] object-contain brightness-0 invert opacity-75 transition-all duration-300 group-hover:opacity-100 sm:h-20 sm:max-w-none md:h-24 ${partner.colorizeBrandOnlyOnHover ? '' : 'group-hover:brightness-100 group-hover:invert-0'}`} data-id="element-300" data-mp="2hqmza3ewe8tn" />
                  {partner.colorizeBrandOnlyOnHover && <img src={partner.logo} alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-contain opacity-0 [clip-path:inset(0_60%_0_0)] transition-opacity duration-300 group-hover:opacity-100" data-id="element-301" data-mp="165ze8auxjbly" />}
                </span>
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}